import i18n from './index.js'
export default {//韩语
  translateText: {
    shoppingcart: "쇼핑 카트",
    loginorrefisterText: "로그인/등록",
    logoutText: "로그아웃",
    personcenterText: "개인 센터",
    placeholderText: "선택하십시오",
    loginText: "로그인",
    registerText: "등록",
    emailText: "이메일",
    pwdText: "비밀번호",
    forgetpwdText: "비밀번호를 잊었나요?",
    nameText: "이름",
    surnameText: "성",
    mobileText: "전화",
    setpwdText: "비밀번호 설정",
    confirmpwdText: "암호 확인",
    countryText: "국가",
    company: "회사",
    birthday: "생일",
    yearText: "년",
    mouthText: "월",
    dayText: "날",
    agreeText1: "저는 읽었고 동의합니다",
    agreeText2: "사용 조건",
    agreeText3: "and",
    agreeText4: "개인 정보 보호지침",
    agreeText5: "그리고 저의 일부 개인 정보는 개인 정보 보호 방침에 따라 해외에서 처리한다는 것에 동의합니다",
    emailplaceholder: "이메일을 입력해주세요",
    subscribetitleText: "뉴스피드 가입",
    subscribeText: "구독",
    sharetoText: "공유하기",
    searchText: "검색",
    subtractmoneyText: "최대 마이너스 600",
    magnanimitycouponText: "많은 쿠폰 받으세요",
    drawText: "즉시 받기",
    discountText: "엄청난 할인",
    purchaseText: "즉시 구매",
    composecouponText: "콤비네이션 구매",
    manyDiscountsText: "많은 혜택이 있습니다",
    recommendtitleText: "당신에게 추천합니다",
    hotsaleproductyitleText: "대박 상품",
    guessLiketitleText: "맘에 드세요",
    NoDataText: "일시 무수함",
    appraiseText: "평가",
    certificate: "쿠폰",
    collectText: "모음집",
    addcartText: "쇼핑 카트에 추가하기",
    enterkeywordsText: "키워드 입력",
    useNowText: "즉시 사용",
    vouchernoText: "쿠폰 번호",
    placeholderyearText: "선택한 해",
    placeholderyearText: "월 선택",
    placeholderyearText: "선택된 날",
    // 优惠券页面
    breadcrumbItemText1: "슈퍼",
    breadcrumbItemText2: "레벨",
    breadcrumbItemText3: "big",
    breadcrumbItemText4: "행복",
    breadcrumbItemText5: "li",
    magnanimitydrawText: "많은 쿠폰을 받으시길 바랍니다",
    availablecouponstitleText: '쿠폰사용 상품',
    drawbtnText: "찾아가세요",
    universalText: "온 장내에 통용되다",
    useText: "사용",
    limitText: "제한",
    fullText: "가득 차",
    subtractText: "빼기",
    // 折扣
    discountitemText1: '할인이 계속되다 ,',
    discountitemText2: '거혜가 꼬리를 물고 있다',
    // 组合
    commoditydiscountitemText1: '콤비네이션 구매 ,',
    commoditydiscountitemText2: '혜택이 많다',
    combinedpriceText: '조합가격',
    economizeText: '절약',
    buynowText: "바로 사기",
    // 产品
    ourproductsText: "우리의 제품",
    productcategoryText: '카테고리',
    recommendtarText: "추천",
    newText: "새로운 제품",
    salesvolumetarText: "판매량",
    pricetarText: "가격",
    // 博客
    blogmanagementText: "핫한 블로그",
    latestblogsText: "최신 블로그",
    relatedrlogsText: "관련 블로그",
    priceIncreasecommentText: "가격인상 평론 」",
    commentsectionTtxt: "댓글 영역",
    participatingcommentsText: "참여 평론 ",
    // 论坛
    postingText: "게시물",
    topicsText: "주제",
    replyText: "답장",
    viewText: "보기",
    lastreplyText: "마지막 회답",
    publishText: "게시",
    placeholdertypeText: "테마 분류를 선택하십시오",
    placeholdertitleText: "제목을 입력해 주세요",
    placeholdercontentsText: "내용을 입력하세요",
    fromtopicText: "테마에서",
    firstfloor: "1 층",
    floorText: "빌딩",
    fromText: "from",
    postreplyText: "답장을 보내기",
    // 个人中心 - 我的订单
    myorderText: "내 주문서",
    mycommentsText: "내 코멘트",
    mycollectionText: "내 모음집",
    couponText: "쿠폰",
    shippingaddressText: "수신 주소",
    myPostText: "내 게시물",
    personalinformationText: "개인 정보",
    editText: "편집",
    allordersText: "모든 주문",
    unpaidText: "지불이 기다리고 있습니다",
    shippedText: "발송 준비 중",
    receivedText: "수령을 기다리는 중",
    evaluatedText: "평가될 예정",
    baidText: "대금납부",
    completedText: "완료",
    productinfText: "제품 정보",
    unitpricethText: "단가",
    quantitythText: "수량",
    actualpaymentthText: "실제 지불",
    transactionstatusthText: "트랜잭션 상태",
    operationthText: "동작",
    ordernumberText: "주문 번호",
    orderdetailsText: "주문 정보",
    cancelorderText: "주문 취소",
    confirmText: "확인",
    cancelText: "취소",
    deleteordertitle: "현재 주문을 삭제하시겠습니까?",
    successfultradeText: "거래가 성공했습니다",
    paymentText: "지불",
    confirmreceiptText: "수신 확인",
    nncommentText: "잠시 설명 없음",
    // 个人中心 - 我的评论
    productText: "제품",
    productdetailText: "평가 자세한 정보",
    replyblogText: "블로그에 답장",
    //个人中心 - 收货地址
    addseliveryaddressText: "새로운 수신주소",
    addaddresstitleText1: "저장되었음",
    addaddresstitleText2: "바 주소, 저장할 수 있습니다",
    addaddresstitleText3: "바 주소",
    defaultText: "기본",
    consigneeText: "수취인",
    addressText: "주소",
    fulladdressText: "상세한 주소",
    setdefaultText: "기본값으로 설정",
    mobilephoneText: "mobile:",
    viewmoreText: "더 보기",
    replypostText: "답장",
    // 个人中心 - 个人信息
    nameLabel: "이름",
    sexlabel: "성별",
    modifyavatarText: "아바타 수정",
    sexmanText: "남자",
    sexwomanText: "여성",
    secrecyText: "비밀",
    replaceText: "변경",
    saveText: "저장",
    oldpasswordText: "원본 암호",
    newpasswordText: "새로운 비밀번호",
    confirmpasswordText: "암호 확인",
    opdpleasolderText: "원래 암호를 입력해 주세요",
    newpleasolderText: "새 암호를 입력해 주세요",
    unboundText: "바인딩되지 않음",
    bindingText: "바인딩",
    unbindingText: "풀다",
    // 个人中心-个人信息
    regionText: "소재 지역",
    addconsigneleasolderText: "성명을 명기를 기입 하세요",
    countrypleasolderText: "국가를 선택하세요",
    provinceleasolderText: "성을 선택하십시오",
    citypleasolderText: "시장을 선택해주세요",
    areapleasolderText: "영역을 선택하십시오",
    fulladdressTextpleasolderText: "상세 한 주소를 입력하십시오",
    addconsignephoneleasolderText: "수하인 휴대전화 번호를 기입 하세요",
    emailpleasolderText: "이메일 주소를 입력해주세요",
    phoneText: '핸드폰 번호',
    uploadimgText: "이미지 업로드",
    updateuserface: "프로필 수정",
    uploadimgtitle1: "이미지 jpg, jpeg, png 파일 지원",
    uploadimgtitle2: "권장 크기:200*200 또는 같은 크기 이미지",
    updateemailText: "편지함 수정",
    updatemobileText: "핸드폰 번호 변경",
    dialogemailtitle: "이메일 주소",
    dialogmobiletitle: "핸드폰 번호",
    dialogheadertitle: "비니더 계정에 연결된 입력",
    continueText: "계속",
    verificationinformation: "검증된 정보",
    verificationinformationtitle1: "을 계속 하기를 원하시면이 검증 절차를 밟게 된다.」고 말하였다",
    verificationinformationtitle2: "검증 사이즈를 보 냈다.아래에 입력하십시오",
    verificationcode: "는인증 코드입니다",
    newtitle: "새로운",
    dialognewmobiletitle: "새로운 휴대전화 번호를 입력하십시오.변경 확인을 누르십시오",
    confirmpbtnText: "확인",
    titlecpuntryselect: "국가 선택",
    hotcountrytitle: "핫 컨트리",
    aboutusText: "우리에 대해서",
    // 订单详情
    havequestionsText:"의문이 있다",
    preferentialText:"특혜",
    enquiryText:"가격 문의",
    combinationdiscountText:"콤보 할인",
    introduceText:"소개",
    buyermycommentsText:"소비자 리뷰",
    starText:"별",
    yourmailboxText:"당신의 편지함",
    placeholderquestionText:"질문을 적어주세요",
    uploadimglimtText:"jpg/gif/png 파일을 올려주세요.이미지 크기는 2mb를 넘지 않습니다",
    submitbtnText:"제출",
    // 购物车
    selectText:"선택",
    tipscartsText:"선택된 제품 (배송비 제외)",
    settlementText:"결산",
    selectallText:"모두 선택",
    amountText:"금액",
    addtofavoritesText:"즐겨찾기 추가",
    havecollectedText:"모음집",
    tipdelecteproduct:"현재 제품을 삭제하시겠습니까?",
    deleteText:"삭제",
    tipclearcart:"쇼핑 카트를 비우시겠습니까?",
    clearcartText:"쇼핑 카트 지우기",
    totalText:"합계",
    totaltipText:"물품 (배송비 제외)",
  }
}




// WEBPACK FOOTER //
// ./src/assets/language/local_ko.js